import { useEffect, useState } from 'react'

/**
 * Alternative method to chakra-ui useMediaQuery which returns true initially when the
 * media query is supposed to be false. That causes a flash of unstyled content,
 * if using this with min-width it cannot be true initially.
 *
 * @see related issue https://github.com/chakra-ui/chakra-ui/issues/3580
 * @see future PR to replace this? https://github.com/chakra-ui/chakra-ui/pull/6402
 * @see based on https://observablehq.com/@werehamster/avoiding-hydration-mismatch-when-using-react-hooks
 */
export default function useMediaQuery(mediaQueryString: string) {
  const [matches, setMatches] = useState<boolean|null>(null)

  useEffect(() => {
    const mediaQueryList = window.matchMedia(mediaQueryString)
    const listener = () => setMatches(!!mediaQueryList.matches)

    listener()
    mediaQueryList.addEventListener('change', listener)

    return () => mediaQueryList.removeEventListener('change', listener)
  }, [mediaQueryString])

  return matches
}
